import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from "../pages/NotFound";
import Dashboard from "../pages/dashboard/page";
import Operations from "../pages/operations/page";
import NewOperation from "../pages/operations/new/page";
import OperationsRisk from "../pages/operations/risk/page";
import OperationsTasks from "../pages/operations/tasks/page";
import OperationsIncidents from "../pages/operations/incidents/page";
import OperationsDocuments from "../pages/operations/documents/page";
import OperationsWorkflow from "../pages/operations/workflow/page";
import OperationsReports from "../pages/operations/reports/page";
import CRM from "../pages/crm/page";
import CRMContacts from "../pages/crm/contacts/page";
import CRMOpportunities from "../pages/crm/opportunities/page";
import CRMFollowups from "../pages/crm/followups/page";
import CRMStatements from "../pages/crm/statements/page";
import CRMContracts from "../pages/crm/contracts/page";
import CRMClientIncidents from "../pages/crm/client-incidents/page";
import CRMReports from "../pages/crm/reports/page";
import Portal from "../pages/portal/page";
import ERP from "../pages/erp/page";
import Reports from "../pages/reports/page";
import Users from "../pages/users/page";
import Settings from "../pages/settings/page";
import Audit from "../pages/audit/page";
import Integrations from "../pages/integrations/page";

const ERPReceivables = lazy(() => import('../pages/erp/receivables/page'));
const ERPPayables = lazy(() => import('../pages/erp/payables/page'));
const ERPBanks = lazy(() => import('../pages/erp/banks/page'));
const ERPAccounting = lazy(() => import('../pages/erp/accounting/page'));
const ERPStatements = lazy(() => import('../pages/erp/statements/page'));
const ERPThirdParty = lazy(() => import('../pages/erp/thirdparty/page'));
const ERPInvoicing = lazy(() => import('../pages/erp/invoicing/page'));
const ERPCatalog = lazy(() => import('../pages/erp/catalog/page'));
const ERPReports = lazy(() => import('../pages/erp/reports/page'));

// Portal de Clientes
const PortalOperations = lazy(() => import('../pages/portal/operations/page'));
const PortalDocuments = lazy(() => import('../pages/portal/documents/page'));
const PortalStatements = lazy(() => import('../pages/portal/statements/page'));
const PortalInvoices = lazy(() => import('../pages/portal/invoices/page'));
const PortalPayments = lazy(() => import('../pages/portal/payments/page'));
const PortalMessages = lazy(() => import('../pages/portal/messages/page'));
const PortalProfile = lazy(() => import('../pages/portal/profile/page'));
const PortalSupport = lazy(() => import('../pages/portal/support/page'));

// Reportes Globales
const ReportsOperational = lazy(() => import('../pages/reports/operational/page'));
const ReportsFinancial = lazy(() => import('../pages/reports/financial/page'));
const ReportsCommercial = lazy(() => import('../pages/reports/commercial/page'));
const ReportsClients = lazy(() => import('../pages/reports/clients/page'));
const ReportsManagers = lazy(() => import('../pages/reports/managers/page'));
const ReportsIncidents = lazy(() => import('../pages/reports/incidents/page'));
const ReportsProductivity = lazy(() => import('../pages/reports/productivity/page'));
const ReportsDesigner = lazy(() => import('../pages/reports/designer/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/operations",
    element: <Operations />,
  },
  {
    path: "/operations/new",
    element: <NewOperation />,
  },
  {
    path: "/operations/risk",
    element: <OperationsRisk />,
  },
  {
    path: "/operations/tasks",
    element: <OperationsTasks />,
  },
  {
    path: "/operations/incidents",
    element: <OperationsIncidents />,
  },
  {
    path: "/operations/documents",
    element: <OperationsDocuments />,
  },
  {
    path: "/operations/workflow",
    element: <OperationsWorkflow />,
  },
  {
    path: "/operations/reports",
    element: <OperationsReports />,
  },
  {
    path: "/crm",
    element: <CRM />,
  },
  {
    path: "/crm/contacts",
    element: <CRMContacts />,
  },
  {
    path: "/crm/opportunities",
    element: <CRMOpportunities />,
  },
  {
    path: "/crm/followups",
    element: <CRMFollowups />,
  },
  {
    path: "/crm/statements",
    element: <CRMStatements />,
  },
  {
    path: "/crm/contracts",
    element: <CRMContracts />,
  },
  {
    path: "/crm/client-incidents",
    element: <CRMClientIncidents />,
  },
  {
    path: "/crm/reports",
    element: <CRMReports />,
  },
  {
    path: "/portal",
    element: <Portal />,
  },
  {
    path: "/portal/operations",
    element: <PortalOperations />,
  },
  {
    path: "/portal/documents",
    element: <PortalDocuments />,
  },
  {
    path: "/portal/statements",
    element: <PortalStatements />,
  },
  {
    path: "/portal/invoices",
    element: <PortalInvoices />,
  },
  {
    path: "/portal/payments",
    element: <PortalPayments />,
  },
  {
    path: "/portal/messages",
    element: <PortalMessages />,
  },
  {
    path: "/portal/profile",
    element: <PortalProfile />,
  },
  {
    path: "/portal/support",
    element: <PortalSupport />,
  },
  {
    path: "/erp",
    element: <ERP />,
  },
  {
    path: "/erp/receivables",
    element: <ERPReceivables />,
  },
  {
    path: "/erp/payables",
    element: <ERPPayables />,
  },
  {
    path: "/erp/banks",
    element: <ERPBanks />,
  },
  {
    path: "/erp/accounting",
    element: <ERPAccounting />,
  },
  {
    path: "/erp/statements",
    element: <ERPStatements />,
  },
  {
    path: "/erp/thirdparty",
    element: <ERPThirdParty />,
  },
  {
    path: "/erp/invoicing",
    element: <ERPInvoicing />,
  },
  {
    path: "/erp/catalog",
    element: <ERPCatalog />,
  },
  {
    path: "/erp/reports",
    element: <ERPReports />,
  },
  {
    path: "/reports",
    element: <Reports />,
  },
  {
    path: "/reports/operational",
    element: <ReportsOperational />,
  },
  {
    path: "/reports/financial",
    element: <ReportsFinancial />,
  },
  {
    path: "/reports/commercial",
    element: <ReportsCommercial />,
  },
  {
    path: "/reports/clients",
    element: <ReportsClients />,
  },
  {
    path: "/reports/managers",
    element: <ReportsManagers />,
  },
  {
    path: "/reports/incidents",
    element: <ReportsIncidents />,
  },
  {
    path: "/reports/productivity",
    element: <ReportsProductivity />,
  },
  {
    path: "/reports/designer",
    element: <ReportsDesigner />,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/audit",
    element: <Audit />,
  },
  {
    path: "/integrations",
    element: <Integrations />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
